@if(isBorder){
<div class="full-screen-div" *ngIf="isBorder">

    <router-outlet></router-outlet>

</div>

}@else{
<router-outlet></router-outlet>
}
<!-- full-screen loader while the whitelabel details load (pre-login pages) -->
<app-whitelabel-loader></app-whitelabel-loader>
<small class="build-info">{{buildInfo?.buildNumber}}</small>